var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaratIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(889 14)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-889 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.646,5.646a.5.5,0,0,1,.707,0L8,10.293l4.646-4.646a.5.5,0,1,1,.707.707l-5,5a.5.5,0,0,1-.707,0l-5-5A.5.5,0,0,1,2.646,5.646Z",
    transform: "translate(891.5 15.5)",
    fill: "#0f3a7b",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaratIconNew);
export default __webpack_public_path__ + "static/media/carat-icon-new.49f3f1a6c6cdecf99c1630c24abfd480.svg";
export { ForwardRef as ReactComponent };